define('webshopProductsCategoriesListAutocompleteView',[
  'webshopProductsCategoriesI18n',
  'module',
  'underscore',
  'tableFieldView',
  'modalsAlertView'
], function (
  translate,
  Module,
  _,
  FieldView,
  AlertView
) {
  'use strict';

  /**
   * Base cell with a category autocomplete input (".empty .search" in the
   * template) fed by tableView.getAllCategories().
   *
   * Subclasses implement:
   *  - isExcluded(category): hides a suggestion (already used, ...)
   *  - onSelect(category): called with the chosen category
   *  - refresh(): returns a promise, reloads the model after update()
   * and call update(request) to run an update with the cell loader.
   */
  Module.exports = FieldView.extend({
    ui: {
      chip: '.chip',
      search: '.empty .search',
      loader: '.loader-2'
    },

    events: {
      'mousedown': 'onMouseDown',
      'dblclick': 'stop',
      'focus @ui.search': 'onSearchInput',
      'input @ui.search': 'onSearchInput',
      'keydown @ui.search': 'onSearchKeyDown',
      'blur @ui.search': 'closeSuggestions'
    },

    initialize: function () {
      FieldView.prototype.initialize.apply(this, arguments);
      this.loading = false;
      this.suggestions = [];
      this.activeIndex = -1;
      this.$suggestions = null;
      this.onScrollCapture = _.bind(this.closeSuggestions, this);
    },

    onBeforeRender: function () {
      FieldView.prototype.onBeforeRender.apply(this, arguments);
      this.closeSuggestions();
    },

    onRender: function () {
      if (this.loading)
        this.ui.loader.css('display', 'flex');
    },

    onDestroy: function () {
      this.closeSuggestions();
    },

    // the cell actions must not change the row selection
    onMouseDown: function (e) {
      if ($(e.target).closest('.chip, .search, .paste').length > 0)
        e.stopPropagation();
    },

    stop: function (e) {
      e.stopPropagation();
    },

    isExcluded: function () {
      return false;
    },

    onSelect: function () {},

    refresh: function () {
      var defer = $.Deferred();
      defer.resolve();
      return defer.promise();
    },

    // ---------------------------------------------------------------- autocomplete

    onSearchInput: function () {
      var query = this.ui.search.val().trim().toLowerCase();

      this.tableView.getAllCategories().done(_.bind(function (categories) {
        if (this.isDestroyed || !this.ui.search.is(':focus'))
          return;

        var matches = _.filter(categories, _.bind(function (category) {
          if (this.isExcluded(category))
            return false;
          if (query === '')
            return true;
          return category.code.toLowerCase().indexOf(query) >= 0 ||
            category.name.toLowerCase().indexOf(query) >= 0;
        }, this));

        // codes / names starting with the query first
        matches = _.sortBy(matches, function (category) {
          if (query === '')
            return 0;
          if (category.code.toLowerCase().indexOf(query) === 0)
            return 0;
          if (category.name.toLowerCase().indexOf(query) === 0)
            return 1;
          return 2;
        });

        this.showSuggestions(matches.slice(0, 15));
      }, this)).fail(_.bind(function () {
        this.showSuggestions([]);
      }, this));
    },

    onSearchKeyDown: function (e) {
      if (e.which === 40) {          // down
        e.preventDefault();
        this.setActiveSuggestion(this.activeIndex + 1);
      } else if (e.which === 38) {   // up
        e.preventDefault();
        this.setActiveSuggestion(this.activeIndex - 1);
      } else if (e.which === 13) {   // enter
        e.preventDefault();
        e.stopPropagation();
        var category = this.suggestions[this.activeIndex] ||
          (this.suggestions.length === 1 ? this.suggestions[0] : null);
        if (category)
          this.selectSuggestion(category);
      } else if (e.which === 27) {   // escape
        e.preventDefault();
        e.stopPropagation();
        this.ui.search.val('');
        this.closeSuggestions();
        this.ui.search.blur();
      }
    },

    showSuggestions: function (categories) {
      this.suggestions = categories;
      this.activeIndex = categories.length > 0 ? 0 : -1;

      if (!this.$suggestions) {
        this.$suggestions = $('<div class="webshop-products-categories-autocomplete"></div>');
        this.$suggestions.on('mousedown', '.item', _.bind(function (e) {
          // mousedown (before the input blur) so that the selection wins
          e.preventDefault();
          e.stopPropagation();
          var category = this.suggestions[parseInt($(e.currentTarget).attr('data-index'), 10)];
          if (category)
            this.selectSuggestion(category);
        }, this));
        this.$suggestions.on('mouseenter', '.item', _.bind(function (e) {
          this.setActiveSuggestion(parseInt($(e.currentTarget).attr('data-index'), 10));
        }, this));
        $('body').append(this.$suggestions);
        document.addEventListener('scroll', this.onScrollCapture, true);
      }

      this.$suggestions.empty();

      if (categories.length === 0) {
        this.$suggestions.append($('<div class="empty"></div>')
          .text(translate('webshop.products.categories.cell.search.empty', 'No matching category')));
      }

      _.each(categories, function (category, index) {
        var $item = $('<div class="item"></div>').attr('data-index', index);
        $item.append($('<div class="code"></div>').text(category.code));
        if (category.name && category.name !== category.code)
          $item.append($('<div class="name"></div>').text(category.name));
        if (String(category.status) === '0')
          $item.addClass('disabled');
        this.$suggestions.append($item);
      }, this);

      // fixed position: the table body scrolls and would clip the list
      var rect = this.ui.search[0].getBoundingClientRect();
      var maxHeight = Math.max(80, Math.min(260, window.innerHeight - rect.bottom - 10));
      this.$suggestions.css({
        top: rect.bottom + 2,
        left: rect.left,
        minWidth: Math.max(rect.width, 220),
        maxHeight: maxHeight
      });

      this.setActiveSuggestion(this.activeIndex);
    },

    setActiveSuggestion: function (index) {
      if (!this.$suggestions || this.suggestions.length === 0)
        return;

      if (index < 0)
        index = 0;
      if (index > this.suggestions.length - 1)
        index = this.suggestions.length - 1;

      this.activeIndex = index;
      this.$suggestions.find('.item').removeClass('active');
      var $active = this.$suggestions.find('.item[data-index="' + index + '"]');
      $active.addClass('active');

      // keep the active item visible
      var top = $active.position() ? $active.position().top : 0;
      var height = $active.outerHeight() || 0;
      var scrollTop = this.$suggestions.scrollTop();
      var viewHeight = this.$suggestions.innerHeight();
      if (top < 0)
        this.$suggestions.scrollTop(scrollTop + top);
      else if (top + height > viewHeight)
        this.$suggestions.scrollTop(scrollTop + top + height - viewHeight);
    },

    closeSuggestions: function () {
      if (this.$suggestions) {
        this.$suggestions.remove();
        this.$suggestions = null;
        document.removeEventListener('scroll', this.onScrollCapture, true);
      }
      this.suggestions = [];
      this.activeIndex = -1;
    },

    selectSuggestion: function (category) {
      this.closeSuggestions();

      if (this.isExcluded(category))
        return;

      this.ui.search.val(category.code).blur();
      this.onSelect(category);
    },

    update: function (request) {
      this.loading = true;
      this.ui.loader.css('display', 'flex');

      request.done(_.bind(function () {
        this.refresh().always(_.bind(function () {
          this.loading = false;
          if (!this.isDestroyed)
            this.render();
        }, this));
      }, this)).fail(_.bind(function (message) {
        this.loading = false;
        if (!this.isDestroyed)
          this.render();
        AlertView.prototype.open(
          translate('webshop.products.categories.error.title', 'Error'),
          message || translate('webshop.products.categories.error.text', 'The update failed'));
      }, this));
    }
  });
});

